import axios from 'axios'
import {ALTERAR_PRESTADOR} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function alterarPrestador (prestador) {
  const url = `${URL}/prestador/alterar`;
  return dispatch => axios.post(url, prestador, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_PRESTADOR,
        payload: response
      })
  );
}
